import { obtainDiscountDataParts } from 'Helpers/DiscountHelper'
import { createRequest, handleErrorCatchLog, renderTranslation } from '../../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'
import { setDiscountData, setLoading } from '../../Slices/Omnichannel/DiscountSlice'
import { Season } from '../../Slices/Omnichannel/SeasonRuleSlice'
import { emptyListingsDiscountToSave } from '../../Slices/Omnichannel/SubRuleSlice'
import { message, notification } from 'antd'
import { TranslationKeys } from 'Constants/TranslationKeys'
import { ReactNode } from 'react'

const getDiscountData = (ruleId: number, season: Season, noDataMessage?: ReactNode) => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const language = state.present.language.value

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  dispatch(setLoading(true))

  const isSuperCategoryEnabled = state.present.configuration.isSuperCategoryEnabled
  const typeOfChannel = state.present.discount.typeOfChannel
  const pricelistTypeFilter = state.present.configuration.pricelistTypeFilter
  const url = `/api/mprules/${ruleId}/discounts/?config=${state.present.article.serverConfig}`
  const queryString =
    `&typeOfChannel=${typeOfChannel}&isSuperCategoryEnabled=${isSuperCategoryEnabled}` +
    `&pricelistTypeFilter=${pricelistTypeFilter}`

  return createRequest(url + queryString, 'POST', season || {}, token)
    .then(response => response.json())
    .then(data => {
      if (data.ruleId == 0) return //se è stata fatta la chiamata per un id regola (nell'url) con cambio di tipo di canale
      dispatch(setDiscountData(data))
      const brandsMap = obtainDiscountDataParts(data)[1]
      if (brandsMap.size === 0)
        notification.open({
          message: '',
          description: noDataMessage,
        })
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed on retrieve discounts getDiscountData')
    })
    .finally(() => {
      dispatch(setLoading(false))
    })
}

const updateDiscount = (ruleId, isSubRuleUpdate, subRuleDiscounts, isVirtualRule) => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  if (!state.present.article.serverConfig || (ruleId && ruleId < 0) || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  const discountToSave = isSubRuleUpdate ? subRuleDiscounts : state.present.discount.discountToSave

  return createRequest(
    '/api/mprules/' + ruleId + '/updateDiscount/?config=' + state.present.article.serverConfig,
    'POST',
    discountToSave,
    token,
    true,
    true,
  )
    .then(response => {
      if (response.ok && isSubRuleUpdate) {
        dispatch(emptyListingsDiscountToSave())
      }

      if (!isVirtualRule) {
        if (!isSubRuleUpdate) {
          dispatch(getDiscountData(ruleId, undefined))
        }
      }
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed on update discounts updateDiscount')
    })
}

const importDiscountData = (subruleId, fileContent, pretotalrows, preheaders, precode) => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || (subruleId && subruleId < 0) || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const body = {
    filecontent: window.btoa(String.fromCharCode(...new Uint8Array(fileContent))),
    pretotalrows: pretotalrows,
    preheaders: preheaders,
    precode: precode,
  }

  return createRequest(
    '/api/mprules/' + subruleId + '/importDiscountFromFile/?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
  )
    .then(response => response.json())
    .then(data => {
      data.success ? message.info('importato correttamente.') : message.error(data.message)
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed on import discounts importDiscount')
    })
}

const getStatsData = statdata => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return createRequest(
    '/api/mprules/excelStats/?config=' + state.present.article.serverConfig,
    'POST',
    statdata,
    token,
  ).then(response => response.json())
}

export { getDiscountData, updateDiscount, importDiscountData, getStatsData }
